import {
  DatePicker,
  Divider,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { priceToCurrency } from "utils/common";
import * as comboTransactionActions from "./slice";

const { RangePicker } = DatePicker;

const COMBO_TRANSACTION_STATUS = {
  success: {
    label: "Thành công",
    color: "green",
  },
  processing: {
    label: "Chờ thanh toán",
    color: "orange",
  },
};

const RANGE_PRESETS = [
  {
    label: "Hôm nay",
    value: [dayjs(), dayjs()],
  },
  {
    label: "Hôm qua",
    value: [dayjs().add(-1, "d"), dayjs().add(-1, "d")],
  },
  {
    label: "Tuần này",
    value: [dayjs().startOf("week"), dayjs()],
  },
  {
    label: "Tuần trước",
    value: [
      dayjs().subtract(1, "week").startOf("week"),
      dayjs().subtract(1, "week").endOf("week"),
    ],
  },
  {
    label: "Tháng này",
    value: [dayjs().startOf("month"), dayjs()],
  },
  {
    label: "Tháng trước",
    value: [
      dayjs().subtract(1, "month").startOf("month"),
      dayjs().subtract(1, "month").endOf("month"),
    ],
  },
  {
    label: "Tất cả",
    value: [dayjs("01/01/2025", "DD/MM/YYYY"), dayjs()],
  },
];

function ComboTransaction() {
  const dispatch = useDispatch();
  const { transactions, pagination, isLoading } = useSelector(
    (state) => state.expressComboTransaction
  );

  const [searchValue, setSearchValue] = useState({
    status: "",
    range: [dayjs().startOf("month"), dayjs()],
    from: dayjs().startOf("month").format("YYYY-MM-DD"),
    to: dayjs().format("YYYY-MM-DD"),
  });
  const [searchState, setSearchState] = useState({
    status: "",
    range: [dayjs().startOf("month"), dayjs()],
    from: dayjs().startOf("month").format("YYYY-MM-DD"),
    to: dayjs().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    dispatch(
      comboTransactionActions.fetchTransactions({
        ...pagination,
        ...searchValue,
      })
    );
  }, []);

  const onChangeSearchValue = (property, value, refresh) => {
    setSearchValue((prev) => ({ ...prev, [property]: value }));
    if (refresh) {
      setSearchState((prev) => ({ ...prev, [property]: value }));
      dispatch(
        comboTransactionActions.fetchTransactions({
          ...pagination,
          ...searchValue,
          [property]: value,
        })
      );
    }
  };

  const onChangeSearchRange = (dates) => {
    setSearchValue((prev) => ({
      ...prev,
      range: dates,
      from: dates[0].format("YYYY-MM-DD"),
      to: dates[1].format("YYYY-MM-DD"),
    }));
    setSearchState((prev) => ({
      ...prev,
      range: dates,
      from: dates[0].format("YYYY-MM-DD"),
      to: dates[1].format("YYYY-MM-DD"),
    }));
    dispatch(
      comboTransactionActions.fetchTransactions({
        ...pagination,
        ...searchValue,
        from: dates[0].format("YYYY-MM-DD"),
        to: dates[1].format("YYYY-MM-DD"),
      })
    );
  };

  const onTableChange = async (pagination) => {
    dispatch(
      comboTransactionActions.fetchTransactions({
        ...pagination,
        ...searchState,
      })
    );
  };

  const columns = [
    {
      title: "STT",
      align: "center",
      render: (text, record, index) => (
        <Typography.Paragraph
          copyable={{
            text: record._id,
            tooltips: ["Sao chép ID", "Đã sao chép!"],
          }}
        >
          {(pagination.current - 1) * pagination.pageSize + index + 1}
        </Typography.Paragraph>
      ),
    },
    {
      title: "Khách hàng",
      dataIndex: "user",
      render: (user) => (
        <>
          <Typography.Text strong>{user.name}</Typography.Text>
          <Typography.Paragraph>{user.phone}</Typography.Paragraph>
        </>
      ),
    },
    {
      title: "Gói tiết kiệm",
      // dataIndex: "combo",
      render: (record) => (
        <>
          <Typography.Paragraph strong>
            {record.combo.name}
          </Typography.Paragraph>
          <Typography.Paragraph>
            <Tag color="blue">x{record.quantity}</Tag>
            {record.combo.voucher.name} ({record.combo.voucher.code})
          </Typography.Paragraph>
        </>
      ),
    },
    {
      title: "Giá",
      dataIndex: "amount",
      render: (price) => priceToCurrency(price),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: (status) => (
        <Tag color={COMBO_TRANSACTION_STATUS[status].color}>
          {COMBO_TRANSACTION_STATUS[status].label}
        </Tag>
      ),
    },
    {
      title: "Thời gian",
      dataIndex: "createdAt",
      width: "10%",
      render: (createdAt) => moment(createdAt).format("DD/MM/YYYY HH:mm"),
    },
  ];

  return (
    <>
      <Row justify="space-between" align="middle">
        <Typography.Title level={2}>
          [{pagination?.total || "0"}] Lịch sử mua gói tiết kiệm
        </Typography.Title>
        <Space size="middle">
          <RangePicker
            presets={RANGE_PRESETS}
            value={searchValue.range}
            onChange={onChangeSearchRange}
            style={{ width: "250px" }}
          />
          <Select
            onChange={(value) => onChangeSearchValue("status", value, true)}
            value={searchValue.status}
            options={[
              {
                value: "",
                label: "Tất cả",
              },
              ...Object.values(COMBO_TRANSACTION_STATUS),
            ]}
            style={{ width: "140px" }}
          />
        </Space>
      </Row>
      <Divider />
      <Table
        bordered
        loading={isLoading}
        columns={columns}
        dataSource={transactions}
        rowKey={(record) => record._id}
        pagination={pagination}
        onChange={onTableChange}
      />
    </>
  );
}

export default ComboTransaction;
